/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Field_Tax_IdInputs */



/**
* | output |
* | --- |
* | "Tax ID (VAT)" |
*
* @param {Partner_Admin_Field_Tax_IdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_field_tax_id = /** @type {((inputs?: Partner_Admin_Field_Tax_IdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Field_Tax_IdInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Steuernummer (USt-IdNr.)")
	return /** @type {LocalizedString} */ ("Tax ID (VAT)")
});